import { render } from "./Lessonstart.vue?vue&type=template&id=6b9e26b6"
import script from "./Lessonstart.vue?vue&type=script&lang=js"
export * from "./Lessonstart.vue?vue&type=script&lang=js"

import "./Lessonstart.vue?vue&type=style&index=0&id=6b9e26b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__